export default "__VITE_ASSET__g8zTxaIZ__"